const replaceDomainInData = (data) => {
  if (typeof data === "string") {
    let newUrl = data;
    if (
      newUrl.includes(
        "https://whatsapp-media-library.s3.ap-south-1.amazonaws.com"
      )
    ) {
      newUrl = newUrl.replace(
        "https://whatsapp-media-library.s3.ap-south-1.amazonaws.com",
        "https://d3jt6ku4g6z5l8.cloudfront.net"
      );
    }
    if (
      newUrl.includes(
        "https://whatsapp-media-library-1.s3.ap-south-1.amazonaws.com"
      )
    ) {
      newUrl = newUrl.replace(
        "https://whatsapp-media-library-1.s3.ap-south-1.amazonaws.com",
        "https://dc4ardkuedwlq.cloudfront.net"
      );
    }

    if (
      newUrl.includes(
        "https://whatsapp-media-library-stg.s3.ap-south-1.amazonaws.com"
      )
    ) {
      newUrl = newUrl.replace(
        "https://whatsapp-media-library-stg.s3.ap-south-1.amazonaws.com",
        "https://dwbb9b4enii6a.cloudfront.net"
      );
    }

    if (
      newUrl.includes(
        "https://whatsapp-media-library-pre-stg.s3.ap-south-1.amazonaws.com"
      )
    ) {
      newUrl = newUrl.replace(
        "https://whatsapp-media-library-pre-stg.s3.ap-south-1.amazonaws.com",
        "https://d1fviw7lxswn81.cloudfront.net"
      );
    }

    return newUrl;
  }

  if (Array.isArray(data)) {
    return data.map((item) => replaceDomainInData(item));
  }

  if (data && typeof data === "object") {
    const newData = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        newData[key] = replaceDomainInData(data[key]);
      }
    }
    return newData;
  }

  return data;
};

module.exports = {
  replaceDomainInData,
};
